import useStorage from './useStorage'

export default function useSessionStorage<T>(
  key: string,
  initialValue: T
): [T, (value: T) => void] {
  return useStorage<T>('sessionStorage', key, initialValue)
}
